<h4 class="mb-30">Change Password</h4>

<form [formGroup]="passwordForm" autocomplete="none">
  <div class="form-group form-group--sm">
    <label>Current Password</label>
    <div class="input-group">
      <input type="password" class="form-control" placeholder="Enter current password" autocomplete="none"
        id="current-password" formControlName="currentPassword">
        <div class="input-group-append">
          <span class="input-group-icon input-group-icon--password">
            <a href="#" data-toggle="password">
              <svg class="icon"><use xlink:href="#eye-off"></use></svg>
            </a>
          </span>
        </div>
      </div>
      @if (passwordForm.get('currentPassword').errors?.required) {
        <div class="password-strength__text mt-4">
          @if (passwordForm.get('currentPassword').errors?.required) {
            <p><small>Current Password is required</small></p>
          }
        </div>
      }
    </div>
    <div class="form-group form-group--sm">
      <label>New Password</label>
      <div class="input-group">
        <input type="password" class="form-control" placeholder="Choose new password" autocomplete="none" id="password"
          formControlName="password">
          <div class="input-group-append">
            <span class="input-group-icon input-group-icon--password">
              <a href="#" data-toggle="password">
                <svg class="icon"><use xlink:href="#eye-off"></use></svg>
              </a>
            </span>
          </div>
        </div>
        <div class="password-strength is-active" [class]="passwordStrength.indiClass">
          <div class="password-strength__track">
            <div class="password-strength__indi"
              [style.width.%]="passwordStrength.strength"
            ></div>
          </div>

          <div class="password-strength__text">
            <p>
              <small>
                @if (!passwordStrength.message) {
                  Your password must be at least 8 characters long and must contain at least one uppercase letter and one
                  number.
                }
                @if (passwordStrength.message) {
                  <strong>{{passwordStrength.messageTitle}}</strong> {{passwordStrength.message}}
                }
              </small>
            </p>
          </div>
        </div>
      </div>
      <div class="form-group form-group--sm">
        <label>Confirm Password</label>
        <div class="input-group">
          <input type="password" class="form-control" placeholder="Confirm new password" autocomplete="none"
            id="confirm-password" formControlName="confirmPassword">
            <div class="input-group-append">
              <span class="input-group-icon input-group-icon--password">
                <a href="#" data-toggle="password">
                  <svg class="icon"><use xlink:href="#eye-off"></use></svg>
                </a>
              </span>
            </div>
          </div>
          @if (passwordForm.get('confirmPassword').errors?.required || passwordForm.get('confirmPassword').errors?.mismatch) {
            <div class="password-strength__text mt-4">
              @if (passwordForm.get('confirmPassword').errors?.required) {
                <p><small>Confirm Password is required</small></p>
              }
              @if (passwordForm.get('confirmPassword').errors?.mismatch) {
                <p><small><strong>Try again</strong>. Passwords do
              not match</small></p>
            }
          </div>
        }
      </div>
    </form>


    <!--<ng-container *ngIf="!submitted && minLengthValid && requiresDigitValid && requiresUppercaseValid && requiresLowercaseValid">
    Your password must be at least 8 characters long and must contain at least one uppercase letter and one number.
  </ng-container>
  <ng-container *ngIf="submitted && !requiresLowercaseValid">
    <strong>Try again</strong>. Your password must contain at least one lowercase letter.
  </ng-container>
  <ng-container *ngIf="submitted && !requiresUppercaseValid">
    <strong>Try again</strong>. Your password must contain at least one uppercase letter.
  </ng-container>
  <ng-container *ngIf="submitted && !requiresDigitValid">
    <strong>Try again</strong>. Your password must contain at least one digit.
  </ng-container>
  <ng-container *ngIf="submitted && !minLengthValid">
    <strong>Try again</strong>. Your password must contain at least 8 characters.
  </ng-container>-->
